import {
	USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE,
	USER_SEGMENTATION_TEAM_TYPE_HR,
	USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
	UserSegmentationTeamTypes,
} from '../../models/user-segmentation';

/**
 * JSMGROWTH-583: team types that are offered a ServCo (JSM / CSM) template on the
 * Jira signup template choice screen. Experiment exposure is only fired for these.
 */
export const SERVCO_ELIGIBLE_TEAM_TYPES: readonly UserSegmentationTeamTypes[] = [
	USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
	USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE,
	USER_SEGMENTATION_TEAM_TYPE_HR,
];

export const isServCoEligibleTeamType = (teamType: UserSegmentationTeamTypes): boolean =>
	SERVCO_ELIGIBLE_TEAM_TYPES.includes(teamType);
